"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledUncontrolledTooltip = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _reactstrap = require("reactstrap");
var _constants = require("../../constants/");
var StyledUncontrolledTooltip = exports.StyledUncontrolledTooltip = function StyledUncontrolledTooltip(props) {
  return _react["default"].createElement(_reactstrap.UncontrolledTooltip, (0, _extends2["default"])({}, props, {
    style: tooltipStyle,
    delay: _constants.TOOL_TIP_DELAY
  }));
};
var tooltipStyle = {
  color: '#000000',
  backgroundColor: '#ffffff'
};